const H1Style = (theme) => {

    return {
      fontSize: "18pt",
      fontWeight: 600,
      color: theme.palette.primary.main,
    };
  };
  
  export default H1Style;
  